import { MESSAGE, PROMOTION_VIDEO } from "../../constants/actionTypes";
import * as api from "../../api/index.js";

export const promotion_video_list = (formData) => async (dispatch) => {
  try {
    const { data } = await api.promotion_video_list(formData);
    dispatch({ type: PROMOTION_VIDEO, payload: data });
    return data
  } catch (error) {
    console.log(error);
  }
};
export const promotion_video_update = (formData) => async (dispatch) => {
  try {
    const { data } = await api.promotion_video_update(formData);
    dispatch({ type: MESSAGE, payload: data });
    return data
  } catch (error) {
    console.log(error);
  }
};
